var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"button",staticClass:"btn exact-center",class:_vm.buttonClasses(),style:({
    minWidth: _vm.width,
  }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.onButtonClick}},[(_vm.loading)?_c('Spinner',{attrs:{"size":"20"}}):_c('span',[_vm._v(_vm._s(_vm.label))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }